import React from 'react';

const ErrorFallback = ({error}) => {
    if (error) {
      window.location.href = `/apps/jcom/router.mvc?error=true`;
    }
    return (
      <div role="alert">
        <p>Something went wrong:</p>
        <pre>{error.message}</pre>
      </div>
    )
  }

export default ErrorFallback